import axios from 'axios';

const client = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
});

let requestInterceptorId = null;
let responseInterceptorId = null;

const pendingRequests = new Map();

const getRequestKey = (config) =>
  `${config.method}:${config.url}:${JSON.stringify(config.params || {})}:${JSON.stringify(config.data || {})}`;

export const setupInterceptors = (getToken, onUnauthorized) => {
  if (requestInterceptorId !== null) {
    client.interceptors.request.eject(requestInterceptorId);
    requestInterceptorId = null;
  }

  if (responseInterceptorId !== null) {
    client.interceptors.response.eject(responseInterceptorId);
    responseInterceptorId = null;
  }

  pendingRequests.clear();

  requestInterceptorId = client.interceptors.request.use(
    (config) => {
      const token = getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      if (config.skipDeduplication !== true) {
        config.requestKey = getRequestKey(config);
      }

      return config;
    },
    (error) => Promise.reject(error),
  );

  responseInterceptorId = client.interceptors.response.use(
    (response) => {
      if (response.config && response.config.requestKey) {
        pendingRequests.delete(response.config.requestKey);
      }
      return response;
    },
    (error) => {
      if (error.config && error.config.requestKey) {
        pendingRequests.delete(error.config.requestKey);
      }

      if (error.response && error.response.status === 401) {
        onUnauthorized();
      }

      return Promise.reject(error);
    },
  );
};

export default client;
